import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAllEnvList, getHDEnvListByUserID, bindUserEnv } from '@/api/gmtool/packageCode';
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      valuearray: [],
      form: {
        id: ''
      },
      user_id: '',
      getProdData: [],
      options: [],
      rules: {
        title: [{
          required: true,
          message: "请输入角色名称",
          trigger: "blur"
        }]
      }
    };
  },
  mounted: function mounted() {},
  created: function created() {},
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.options = e;
    },
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var getProdData, getRoleProdData, list;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;
                _context.next = 3;
                return getAllEnvList();

              case 3:
                getProdData = _context.sent;

                if (getProdData.status == 200) {
                  getProdData.data.map(function (i) {
                    i.value = i.id;
                    i.label = i.name;
                  });
                  _this.getProdData = getProdData.data;
                }

                if (!id) {
                  _context.next = 11;
                  break;
                }

                _this.user_id = id;
                _context.next = 9;
                return getHDEnvListByUserID({
                  user_id: id
                });

              case 9:
                getRoleProdData = _context.sent;

                if (getRoleProdData.status == 200) {
                  list = [];

                  _this.getProdData.forEach(function (i) {
                    if (getRoleProdData.data.findIndex(function (k) {
                      return k.id == i.value;
                    }) > -1) {
                      list.push(i);

                      _this.$refs.gamemultipleTable.toggleRowSelection(i, true);
                    }
                  });

                  _this.options = list;
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.user_id = '';
      this.getProdData = [];
      this.dialogFormVisible = false;
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var arr;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                arr = _this2.options.map(function (i) {
                  return i.value;
                }).toString();
                bindUserEnv({
                  user_id: _this2.user_id,
                  env_ids: arr
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.$message.success('设置成功');

                    _this2.resetForm();
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};